import * as React from 'react';
import { Calendar, View, dateFnsLocalizer } from 'react-big-calendar';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import startOfWeek from 'date-fns/startOfWeek';
import getDay from 'date-fns/getDay';
import sv from 'date-fns/locale/sv';
import { BookableTimes } from './viewLocationAndDate';

const allViews: View[] = ['month'];
const locales = {'sv-SE': sv};
const culture = 'sv-SE';
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales
});

interface CalendarProps {
  resourceTitle: string;
  bookableTimes: BookableTimes[];
  selectDate: (selectDate: Date) => void;
}

export function DayCalendar({resourceTitle, bookableTimes, selectDate}: CalendarProps) {

  const handleSelect = (value: Date) => {
    selectDate(value);
  };

  // Filters out saturdays and sundays
  const filteredTimes = bookableTimes.filter(
    item => getDay(item.start) !== 0
      && getDay(item.start) !== 6
      && format(item.start, 'PPPP', {locale: sv}) !== format(new Date(), 'PPPP', {locale: sv}));

  return (
    <div className='calendar'>
      <h3 className='calendar-header'>Välj önskad dag på vår anläggning i {resourceTitle}</h3>
      {localizer &&
      <Calendar
        localizer={localizer}
        culture={culture}
        selectable
        events={filteredTimes}
        startAccessor="start"
        endAccessor="end"
        views={allViews}
        titleAccessor="title"
        onSelectEvent={slot => handleSelect(slot.start as Date)}
        messages={{
          day: 'Månad',
          week: 'Vecka',
          month: 'Månad',
          today: 'Idag',
          previous: 'Backa',
          next: 'Framåt'
        }}
        style={{ height: 370 }}
      />}
    </div>
  );
}